import React from 'react';
import { Modal, Form, Input } from 'antd';

const FormItem = Form.Item;

const EditProfileForm = Form.create()((props) => {
  const {
    form, modalVisible, handleModalVisible, handleSubmit, editingTenant,
  } = props;

  const handleOk = () => {
    form.validateFields((err, fieldsValue) => {
      if (err) return;
      handleSubmit(fieldsValue);
      handleModalVisible(false);
    });
  };

  const handleCancel = () => {
    form.resetFields();
    handleModalVisible(false);
  };

  return (
    <Modal
      title="Edit Tenant Profile"
      visible={modalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <FormItem labelCol={{ span: 8 }} wrapperCol={{ span: 15 }} label="ID">
        {form.getFieldDecorator('id', {
          initialValue: editingTenant.id,
        })(<Input disabled type="text" />)}
      </FormItem>
      <FormItem labelCol={{ span: 8 }} wrapperCol={{ span: 15 }} label="Name">
        {form.getFieldDecorator('name', {
          initialValue: editingTenant.name,
          rules: [{
            required: true,
            message: 'Tenant name is required.',
          }],
        })(<Input type="text" />)}
      </FormItem>
      <FormItem labelCol={{ span: 8 }} wrapperCol={{ span: 15 }} label="Workspace">
        {form.getFieldDecorator('workspace', {
          initialValue: editingTenant.workspace,
          rules: [{
            required: true,
            message: 'Workspace is required.',
          }],
        })(<Input type="text" />)}
      </FormItem>
      <FormItem labelCol={{ span: 8 }} wrapperCol={{ span: 15 }} label="Authorization Type">
        {form.getFieldDecorator('authType', {
          initialValue: editingTenant.authType,
          rules: [{
            required: true,
            message: 'Authorization type is required.',
          }],
        })(<Input type="text" />)}
      </FormItem>
    </Modal>
  );
});

export default EditProfileForm;



// WEBPACK FOOTER //
// ./src/routes/TenantProfile/EditProfileForm.js